import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import LatestArticles from "./components/LatestArticles";
import TrendingSection from "./components/TrendingSection";

export default function Home() {
  return (
    <>
      <Navbar />

      {/* Schema.org WebSite */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "51黑料网",
            url: "http://afvhue.cn/",
            description:
              "51黑料网，专注社会热点、娱乐八卦、科技资讯，提供真实及时的爆料内容",
            potentialAction: {
              "@type": "SearchAction",
              target:
                "http://afvhue.cn/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />

      <main>
        {/* h1 wraps the main heading in Hero for SEO */}
        <HeroSection />
        <CategoryGrid />
        <LatestArticles />
        <TrendingSection />
      </main>

      <Footer />
    </>
  );
}
